document.addEventListener("DOMContentLoaded", function() {
  const form = document.querySelector('form#ContactForm');
  if (!form) return; // No form found

  form.addEventListener("submit", function(event) {
    event.preventDefault(); // Stop default Shopify submission immediately
    console.log("Prevent Default")
  });
});